import { render, staticRenderFns } from "./memoList.vue?vue&type=template&id=0edc116d&"
import script from "./memoList.vue?vue&type=script&lang=js&"
export * from "./memoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports